import { MarkdownContent } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';

const content = `
## Portal técnico del VPS

Este portal reúne el catálogo verificable de aplicaciones, infraestructura,
datos, mensajería y observabilidad desplegados en el VPS.

- [Explorar el catálogo](/catalog)
- [Ver el grafo de relaciones](/catalog-graph)
- [Documentación de arquitectura](/docs/default/component/vps-platform)
- [Grafana](https://monitoring.wgutierrez.dev)

El catálogo es de solo lectura. Los cambios se realizan mediante los YAML bajo
\`/opt/backstage/catalog\`, se validan y se despliegan de forma controlada.
`;

const gettingStartedWidget = HomePageWidgetBlueprint.make({
  name: 'vps-portal',
  params: {
    name: 'VpsPortal',
    title: 'VPS Developer Portal',
    description: 'Accesos principales y documentación operativa',
    components: async () => ({
      Content: () => <MarkdownContent content={content} />,
    }),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [gettingStartedWidget],
});
